<template>
  <base-layout
    page-default-back-link="/home"
    showUserSettings="true"
    showSettings="true"
  >

    <!-- Search Module  -->
    <div v-if="status == 'Search'">
      <ion-grid>
        <ion-row>
          <ion-col size="12" size-md="6">
            <ion-searchbar
              placeholder="Search"
              @ionChange="get_inventories"
              debounce="1000"
              v-model="term"
            ></ion-searchbar>
          </ion-col>
          <ion-col size="12" size-md="6">
            <ion-select
              interface="popover"
              :value="searchConnection"
              @ionChange="connectionFilterFn"
            >
              <ion-select-option
                :value="item"
                v-for="(item, index) in connectionsList"
                :key="index"
                >{{ item }}
              </ion-select-option>
            </ion-select>
          </ion-col>
        </ion-row>
      </ion-grid>

      <div v-if="error!==''" class="login_error ion-text-center">{{ error }}</div>

      <ion-list class="results">
        <ion-item v-for="(inventory, index) in inventories" :key="inventory.inv_id">
          <ion-grid>
            <ion-row>
              <ion-col size="4" size-md="3">
                <ion-label> SKU: </ion-label> {{ inventory.inv_item_ref }}
              </ion-col>
              <ion-col size="8" size-md="5">
                <ion-label> Name: </ion-label> {{ inventory.inv_item_name }}
              </ion-col>
              <ion-col size="12" size-md="4">
                <ion-label>by</ion-label>
                {{ inventory.ent_fullname }}
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" size-md="8">
                <ion-label> Description: </ion-label>
                {{ inventory.inv_description }}
                <br /><br />
                <ion-label> Price: </ion-label>
                ${{ inventory.inv_price }} / {{ inventory.inv_unit }}
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col>
                <div v-if="inventory.inv_returned_date!='0000-00-00'">
                  <ion-label> Returned date: </ion-label>
                  {{ inventory.inv_returned_date }}
                </div>
              </ion-col>
              <ion-col>
                <div v-if="inventory.inv_item_finish!=''">
                  <ion-label> Finish: </ion-label>
                  <span v-html="inventory.inv_item_finish"></span>
                </div>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col>
                <div v-if="inventory.inv_specifications!=''">
                  <ion-label> Specifications: </ion-label>
                  {{ inventory.inv_specifications }}
                </div>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size="12" size-md="4" class="ion-text-right">
                <ion-button size="small" @click="show_inventory(index)">
                  <ion-icon :icon="eyeOutline"></ion-icon> Open
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>
      </ion-list>

      <div v-if="show_scroll">
        <ion-infinite-scroll
          @ionInfinite="loadData($event, true)"
          threshold="100px"
          id="infinite-scroll"
          :disabled="false"
        >
          <ion-infinite-scroll-content
            loading-spinner="bubbles"
            loading-text="Loading more data..."
          >
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </div>
    </div>

    <!-- View inventory's Information Module  -->
    <div v-if="status == 'Inventory_Information'">
      <br>
      <div class="ion-text-right">
        <ion-button size="small" @click="back_to_search(item)">Back</ion-button>
      </div>
      <br>
      <div class="information">
        <ion-grid>
          <ion-row>
            <ion-col size="7">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="12" size-md="4">
                  <ion-label>SKU: </ion-label><br />
                  {{ selected_inventory.inv_item_ref }}<br>
                  <small>{{ selected_inventory.inv_item_vendor_ref }}</small>
                </ion-col>
                <ion-col size="12" size-md="4">
                  <ion-label>Name: </ion-label><br />
                  {{ selected_inventory.inv_item_name }}
                </ion-col>
              </div>
            </ion-col>
            <ion-col size="5" class="ion-text-right">
              <img :src="selected_inventory.image_url" style="max-width:100%;max-height:25vh;" />
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12" size-md="6">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="3">
                  <ion-label>Price: </ion-label>
                </ion-col>
                <ion-col size="9">
                  ${{ selected_inventory.inv_price }} /
                  {{ selected_inventory.inv_unit }}
                </ion-col>
              </div>
            </ion-col>
            <ion-col size="12" size-md="6">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="12">
                  <ion-label>Dimesions: </ion-label><br /><br />
                  <span>{{ selected_inventory.inv_dimensions }}</span><br>
                  <span>{{ selected_inventory.inv_dimensions_metric }}</span>
                </ion-col>
              </div>
            </ion-col>
            <ion-col size="12" size-md="6">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="12">
                  <ion-label>Description: </ion-label><br /><br />
                  <span v-html="selected_inventory.inv_description"></span><br>
                  <span v-html="selected_inventory.inv_item_finish"></span><br>
                  <span v-html="selected_inventory.inv_specifications"></span>
                </ion-col>
              </div>
            </ion-col>
          </ion-row>
          <!--
          <ion-row>
            <ion-col>
              <ion-list>
                <ion-item v-for="transaction in selected_inventory.transactions" :key="transaction.trans_id">
                  <ion-grid>
                    <ion-row>
                      <ion-col>
                        <ion-label>Module:</ion-label>
                        {{transaction.trans_module}}
                      </ion-col>
                      <ion-col>
                        <ion-label>Amount:</ion-label>
                        {{transaction.trans_amount}}
                      </ion-col>
                      <ion-col>
                        <ion-label>Status:</ion-label>
                        {{transaction.trans_status}}
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>
          -->
        </ion-grid>
      </div>
    </div>
  </base-layout>
</template>

<script>
import {
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonItem,
  IonLabel,
  IonList,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonIcon,
  IonSearchbar,
  IonSelect,
  IonSelectOption,
} from "@ionic/vue";
import { searchOutline, eyeOutline } from "ionicons/icons";

export default {
  components: {
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonItem,
    IonLabel,
    IonList,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    IonIcon,
    IonSearchbar,
    IonSelect,
    IonSelectOption,
  },

  data() {
    return {
      status: "Search",

      searchConnection: '- All -',
      connectionsList: ['- All -'],
      connectionsListWithCode: [{ conn_id: 0, conn_name: '- All -' }],

      term: "",
      limit: 20,
      offset: 0,
      show_scroll: false,

      error: "",
      inventories: [],
      selected_inventory: "",

      searchOutline,
      eyeOutline,
    };
  },

  methods: {
    get_inventories() {
      this.inventories = []; // empty result
      this.limit = 20;
      this.offset = 0;
      this.show_scroll = true;
      this.loadData(this.$event, false);
    },

    connectionFilterFn({ detail }) {
      console.log(detail);
      this.searchConnection = detail.value;
      this.inventories = []; // empty result
      this.limit = 20;
      this.offset = 0;
      this.show_scroll = true;
      this.loadData(this.$event, false);
    },

    async loadData(event, call_event) {
      console.log("Load data");

      let conn_id = 0;
      for (let i = 0; i < this.connectionsListWithCode.length; i++) {
        if (this.connectionsListWithCode[i].conn_name == this.searchConnection) {
          conn_id = this.connectionsListWithCode[i].conn_id;
        }
      }

      await this.$store.dispatch("inventory/inventory_search", {
        term: this.term,
        limit: this.limit,
        offset: this.offset,
        conn_id: conn_id,
      });
      this.offset += this.limit;
      var request_error = this.$store.getters["inventory/getRequestError"];

      if (request_error != "") {
        this.error = request_error;
      } else {
        let received_inventories =
          this.$store.getters["inventory/getInventory"];
        console.log(received_inventories);
        for (let i = 0; i < received_inventories.length; i++) {
          this.inventories.push(received_inventories[i]);
        }

        if (received_inventories.length < this.limit) {
          this.show_scroll = false;
        }

        this.error = "";
      }

      if (call_event) event.target.complete();
    },

    async show_inventory(index) {

      // this.selected_inventory = this.inventories[index];
      // this.status = "Inventory_Information";

      await this.$store.dispatch("inventory/inventory", {
        id: this.inventories[index].inv_id,
        conn_id: this.inventories[index].master_conn_id
      });

      var request_error = this.$store.getters["inventory/getRequestError"];

      if (request_error != "") {
        this.error = request_error;
      } else {
        this.error = '';
        this.selected_inventory = this.$store.getters["inventory/getSelectedInventory"];
        console.log(this.selected_inventory);
        this.status = "Inventory_Information";
      }
    },

    back_to_search() {
      const { inv_id } = this.$route.params;
      if (inv_id > 0) {
        this.$router.push({ name:'Scan', params:{ open_scan:0 }});
      } else {
        this.status = "Search"; // Stay in the current page.
      }
    },

    ionViewDidEnter() {
      console.log(" Ion did enter. ");

      const { inv_id } = this.$route.params;

      if (inv_id > 0) {
        var scanResult = this.$store.getters["visits/getItemFromScan"];
        this.selected_inventory = scanResult.inventory;
        this.status = "Inventory_Information";
      } else {
        this.status = "Search";
        var ref = this;

        this.searchConnection = '- All -';
        this.connectionsList = ['- All -'];
        this.connectionsListWithCode = [{ conn_id: 0, conn_name: '- All -' }]

        this.$store.dispatch("various/connections").then( response => {
          if(response.data.success){
              for(let i=0; i<response.data.results.length; i++){
                ref.connectionsList.push(response.data.results[i].conn_name);
                ref.connectionsListWithCode.push(response.data.results[i]);
              }
              ref.searchConnection = ref.connectionsListWithCode[0].conn_name
            } else {
              ref.error = response.message;
            }
        }, request_error => {
            ref.error = request_error;
        })

      }
    },

  },
};
</script>

<style lang="scss" scoped>
.results {
  .conf-name {
    color: #000;
  }

  ion-row {
    background: #ffffff;
    /*     margin-bottom: 10px; */
    padding: 10px;
    border-left: 10px solid #226391;
    height: auto;
  }

  .no-date {
    font-style: italic;
  }

  a {
    text-decoration: none;
  }

  ion-grid {
    height: auto;
  }

  ion-item {
    border: none;
    padding: 0px;
  }

  .item-native {
    padding: 0px;
    padding-inline: 0px;
  }

  .item-inner {
    padding: 0px;
    padding-inline: 0px;
    border: none;
  }

  ion-label {
    font-size: 0.8em;
    font-weight: bold;
    color: #444;
  }
}

.information {

  font-size:0.9em;

  .conf-name {
    color: #000;
  }

  ion-row {
    background: #ffffff;
/*     margin-bottom: 10px; */
    padding: 10px;
    border-left: 10px solid #079602;
    height: auto;
  }

  .no-date {
    font-style: italic;
  }

  a {
    text-decoration: none;
  }

  ion-grid {
    height: auto;
  }

  ion-item {
    border: none;
  }

  ion-label {
    font-size: 0.8em;
    font-weight: bold;
    color: #444;
  }

}

.login_error {
  color: red;
  font-size: 15px;
}
</style>